// extracted by mini-css-extract-plugin
export var draftAttachmentContainer = "_k3-0";
export var fileCarousel = "_k3-2";
export var removeFileButton = "_k3-1";